import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6a649c4d&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=6a649c4d&prod&scoped=true&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=6a649c4d&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.6.14_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a649c4d",
  null
  
)

export default component.exports